import * as React from 'react';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import styled from 'styled-components';
import { DSGrid, DSTypography } from '../mui';
import { Translate } from '../Translate';
import { DSIconButton } from '../Generic/Buttons/DSIconButton';

const CountText = styled(DSTypography).attrs({ variant: 'button' })`
    font-weight: 400;
    font-size: 1rem;
`;

export interface MultiItemPickerNavigatorProps {
    isItem?: boolean;
    max: number;
    min: number;
    value: number;
    onDecrement?: () => void;
    onIncrement?: () => void;
}

export function MultiItemPickerNavigator({
    isItem,
    max,
    min,
    onDecrement,
    onIncrement,
    value,
}: MultiItemPickerNavigatorProps): JSX.Element {
    return (
        <DSGrid alignItems="center" container item={isItem}>
            <DSGrid item>
                <DSIconButton
                    color="primary"
                    data-cy="previous-multi-item-button"
                    data-testid="previous-multi-item-button"
                    disabled={value <= min}
                    onClick={() => onDecrement?.()}
                >
                    <ChevronLeft />
                </DSIconButton>
            </DSGrid>
            <DSGrid item>
                <CountText>
                    <Translate keyId="COMMON.NUM_OF_TOTAL" options={{ num: value, total: max }} />
                </CountText>
            </DSGrid>
            <DSGrid item>
                <DSIconButton
                    color="primary"
                    data-cy="next-multi-item-button"
                    data-testid="next-multi-item-button"
                    disabled={value >= max}
                    id="btnNextImage"
                    onClick={() => onIncrement?.()}
                >
                    <ChevronRight />
                </DSIconButton>
            </DSGrid>
        </DSGrid>
    );
}
MultiItemPickerNavigator.displayName = 'MultiItemPickerNavigator';
